<template>
  <v-dialog v-model="dialogOpen" width="750" persistent>
    <v-card>
      <v-card-title>
        Status History - {{product_id}}
      </v-card-title>
      
      <v-card-text>
        <v-row>
          <v-col>
            <v-data-table :headers="headers" :items="getStatusHistory" disable-sort :loading="getIsStatusHistoryLoading"
            :server-items-length="getPaginationConfigs.paginationCount" :page="getPaginationConfigs.page" :options.sync="options" :footer-props="{ itemsPerPageOptions }">
              <template v-slot:item.datetime="{ item }"><span class="body--text">{{ item.datetime }}</span></template>
              <template v-slot:item.days="{ item }"><span class="body--text">{{ item.days }}</span></template>
              <template v-slot:item.status="{ item }"><span class="body--text">{{ item.status }}</span></template>
              <template v-slot:item.user="{ item }"><span class="body--text">{{ item.user }}</span></template>
              <template v-slot:item.forced="{ item }"><span class="body--text text-center"><v-icon>{{ (item.forced)?'check':'close' }}</v-icon></span></template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small outlined class="ml-3" @click="close">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from "vuex";

  export default {
    props: ['dialogOpen', 'product_id'],

    data() {
      return {
        headers: [
          { text: 'Date & Time', value: 'datetime' },
          { text: 'Days', value: 'days' },
          { text: 'Status', value: 'status' },
          { text: 'User', value: 'user' },
          { text: 'Forced', value: 'forced' },
        ],
        options: {
          itemsPerPage: 25,
          page: 1,
        },
        itemsPerPageOptions: [5,10,15,25,50],
        debounceTimeout: null,
      }
    },

    watch: {
      watchOpenAndOptions: {
        immediate: false,
        deep: true,
        handler(val) {
          const [a, b] = val.split('|');
          if(JSON.parse(a) && JSON.parse(b)) {
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = setTimeout(() => {
              this.fetchStatusHistory({ p_id: this.product_id, options: this.options });
            }, 200);
          }
        }
      }
    },

    computed: {
      ...mapGetters("products/statusHistory", ["getStatusHistory", "getIsStatusHistoryLoading", "getPaginationConfigs"]),

      watchOpenAndOptions() {
        return `${this.dialogOpen}|${JSON.stringify(this.options)}`;
      },
    },

    methods: {
      ...mapActions("products/statusHistory", ["fetchStatusHistory"]),
      ...mapMutations("products/statusHistory", ["RESET_STATUS_HISTORY"]),

      close() {
        this.RESET_STATUS_HISTORY();
        this.$emit('close-dialog');
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
